import { AclState } from "./reducer";

export function customerHasPermissions(
  acl: AclState,
  permissions: string[],
  customerId: string,
): boolean {
  for (let i = 0; i < permissions.length; i++) {
    const permittedCustomers = acl.customerLevel[permissions[i]] || [];

    // if a given permission in acl does not have the right customerId
    // and it is not wildcard and it's not permitted
    if (
      permittedCustomers.indexOf(customerId) === -1 &&
      permittedCustomers.indexOf("*") === -1
    ) {
      return false;
    }
  }

  return true;
}

export function siteHasPermissions(
  acl: AclState,
  permissions: string[],
  siteCompositeId: string,
): boolean {
  for (let i = 0; i < permissions.length; i++) {
    const permittedSiteCustomerPairs = acl.siteLevel[permissions[i]] || [];
    const [customerId, _] = siteCompositeId.split("/");
    const wildcardCustomer = `${customerId}/*`;
    const wildcardSystem = "*/*";

    // if a given permission in acl does not have the right customerId/siteId
    // and it is not wildcard customer (customerId/*) and
    // is not a system wildcard (*/*) it's not permitted
    if (
      permittedSiteCustomerPairs.indexOf(siteCompositeId) === -1 &&
      permittedSiteCustomerPairs.indexOf(wildcardCustomer) === -1 &&
      permittedSiteCustomerPairs.indexOf(wildcardSystem) === -1
    ) {
      return false;
    }
  }

  return true;
}

export function systemHasPermissions(
  acl: AclState,
  permissions: string[],
): boolean {
  for (let i = 0; i < permissions.length; i++) {
    if (acl.systemLevel.indexOf(permissions[i]) === -1) {
      return false;
    }
  }

  return true;
}
